import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RateDroppedTransactions } from '@app/core/errors/rate-dropped-transactions';
import { Context } from '@app/core/patrons/context';
import { catchError, of, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ApiErrorHandlingService implements HttpInterceptor {
    public intercept(req: HttpRequest<any>, next: HttpHandler): any {
        return next.handle(req).pipe(
            catchError((element) => {
                if (!(element.error && element.error.errors && element.error.errors.length > 0)) {
                    return throwError(element);
                }
                // The deals page handles its own `rate_dropped`/`unavailable_deal` (see the deals
                // bag facade); only a transaction's quote change is handled here.
                if (
                    element.error.errors[0].code?.includes('rate_dropped') &&
                    req.url.includes('transactions')
                ) {
                    new Context().setStrategy(new RateDroppedTransactions()).execute();

                    return of(true);
                }

                return throwError(element);
            }),
        );
    }
}
